import { sendPlayEvidence } from './rankingApi';

// Compact [songMilliseconds, lane(0/1), pressed(0/1)] events; no React updates.
export class VerifiedPlaySession {
  constructor(attempt, getTime, onError, send = sendPlayEvidence) {
    this.attempt = attempt; this.getTime = getTime; this.onError = onError; this.send = send;
    this.token = localStorage.getItem('nacanaca-session') || '';
    this.events = []; this.down = [false, false]; this.seq = 0;
    this.time = attempt.clockStartMs; this.chain = Promise.resolve();
    this.timer = null; this.error = null; this.disposed = false;
  }
  sample(seconds) { this.time = Math.max(this.time, Math.min(181000, Math.round(seconds * 1000))); return this.time; }
  input(seconds, lane, pressed) {
    if (this.error || this.disposed) return;
    const index = lane === 'left' ? 0 : 1;
    if (this.down[index] === pressed) return;
    this.down[index] = pressed;
    if (this.events.length >= 512) { this.fail(new Error('Demasiadas entradas pendientes. Inicia otra partida.')); return; }
    this.events.push([this.sample(seconds), index, pressed ? 1 : 0]);
  }
  fail(error) { this.error = error; this.stopTimer(); if (!this.disposed) this.onError?.(error); }
  stopTimer() { clearInterval(this.timer); this.timer = null; }
  startTimer() {
    this.stopTimer();
    this.timer = setInterval(() => this.flush('batch').catch(() => {}), 10000);
  }
  flush(kind, seconds) {
    if (this.error) return Promise.reject(this.error);
    const time = kind === 'ready' ? this.time : this.sample(seconds ?? this.getTime());
    const events = this.events; this.events = [];
    const operation = this.chain.then(async () => {
      if (this.error) throw this.error;
      const payload = { attemptId: this.attempt.id, seq: this.seq, kind, time, events };
      let result;
      try { result = await this.send(payload, this.token); }
      catch (error) {
        // One bounded retry of the exact same batch after ambiguous delivery.
        if (error.status && error.status < 500) throw error;
        result = await this.send(payload, this.token);
      }
      this.seq++;
      return result;
    });
    this.chain = operation.catch((error) => { this.fail(error); });
    return operation;
  }
  async ready() { await this.flush('ready'); if (!this.disposed) this.startTimer(); }
  pause(seconds) { this.stopTimer(); this.down = [false, false]; return this.flush('pause', seconds); }
  async resume() {
    await this.flush('resume', this.time / 1000);
    if (!this.disposed) this.startTimer();
  }
  finish(seconds) { this.stopTimer(); return this.flush('finish', seconds); }
  dispose() { this.disposed = true; this.stopTimer(); this.events = []; }
}
